import './i18n';
import './util/sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Bootstrap from './bootstrap';
import * as serviceWorker from './serviceWorker';
import { initAppCenterSDK } from '@semcore/app-center-js-sdk';
import { createParentSemrushBridge, createStandaloneSemrushBridge } from './core/config';

const MAX_RETRIES = 50;
let retries = 0;

configureSemrushBridge();

if (!('SM' in window)) {
    initAppCenterSDK();
}

injectSemrushSDK()
    .then(bootstrap)
    .catch(error => {
        console.error('Error initializing SM', error);
    });

async function injectSemrushSDK() {
    configureSemrushBridge();

    do {
        if (retries > 0) {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        if ('SM' in window && window.SM?.['init']) {
            try {
                // @ts-ignore
                await window.SM.init();
                return;
            } catch (error) {
                console.error('Error initializing SM', error);
            }
        }

        ++retries;
    } while (retries++ < MAX_RETRIES);

    throw new Error('Failed to initialize SM');
}

function configureSemrushBridge() {
    const params = new URLSearchParams(window.location.search);
    const hostOrigin = params.get('hostOrigin');
    const useParentBridge = params.get('hostBridge') === 'parent' && !!hostOrigin && window.parent !== window;
    const isLocalStandalone = window.parent === window && ['localhost', '127.0.0.1'].includes(window.location.hostname);
    const localJwt = params.get('jwt') || process.env.REACT_APP_JWT_DEV || '';

    if (useParentBridge) {
        // @ts-ignore
        window.SM = createParentSemrushBridge(window, hostOrigin);
        return;
    }

    if (isLocalStandalone) {
        // @ts-ignore
        window.SM = createStandaloneSemrushBridge(localJwt);
    }
}

function bootstrap() {
    const container = document.getElementById('root');
    const root = createRoot(container);

    root.render(
        <React.StrictMode>
            <Bootstrap />
        </React.StrictMode>,
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
}

// trigger deployment
